/**
 * Settings Module Routes
 *
 * Route definitions for the Settings overview page.
 */

import type { RouteRecordRaw } from 'vue-router'
import ModuleLayout from '@/layouts/ModuleLayout.vue'

const routes: RouteRecordRaw[] = [
    {
        path: '/settings',
        component: ModuleLayout,
        meta: {
        },
        children: [
            {
                path: '',
                name: 'settings-overview',
                component: () => import('./views/SettingsOverview.vue'),
                meta: {
                    title: 'Settings',
                },
            },
        ],
    },
]

export default routes
